import type { FiltersConfigState } from '@/reducers/filtersConfig';
import { SearchState } from '@/reducers/search';
import { isSearchSaved } from '@/shared/helpers/SavedSearches/matcher';
import { mapToSavedSearch } from '@/shared/helpers/SavedSearches/stateTranslator';
import { FloatingButtonState } from '..';
import { DisplayStrategyCallback } from '.';

export function create(state: FloatingButtonState): DisplayStrategyCallback {
  return (search: SearchState, filtersConfig: FiltersConfigState) => {
    return Promise.resolve(
      state.firstFetchDone &&
        !isSearchSaved(
          mapToSavedSearch(search, filtersConfig),
          state.savedSearchesIndex || {}
        )
    );
  };
}
